<template>
    <card v-if="registrations.length > 0">

        <h3 class="mb-0" slot="header">{{ $t('users.sessions-data') }}</h3>

        <div class="text-left mb-4">

            <div class="mb-3" v-for="(registration, index) in registrations" :key="index">

                    <p class="registration">
                        <router-link :to="cohortRoute(registration)">
                            {{ registration.cohort.name }}
                        </router-link>
                        >
                        <router-link :to="degreeRoute(registration)">
                            {{ registration.degree.name }}
                        </router-link>
                    </p>

                    <ul class="simulations">
                        <li class="simulation" v-for="(simulation, index2) in registration.simulations" :key="index2">
                            <strong>{{ simulation.name }}:</strong>
                            <router-link :to="simulationRoute(registration, simulation)">
                                {{ simulation.count.sessions }} sessions
                            </router-link>,
                            <router-link :to="issuesRoute(registration, simulation)">
                                {{ simulation.count.issues }} issues
                            </router-link>
                        </li>
                    </ul>
            </div>
        </div>

    </card>
</template>

<script>
    export default {

        props: {
            id: {
                type: [String, Number],
                required: true
            },
        },

        data() {
            return {
                endpoint: this.$baseURL + '/astral/api/front/dashboard/users/' + this.id + '/protected-data',
                registrations: []
            }
        },

        created() {
            axios.get(this.endpoint).then(resp => {
                this.registrations = resp.data.data
            })

        },

        methods: {

            cohortRoute(registration) {
                return '/astral/ui/dashboard/cohorts/' + registration.cohort.id
            },

            degreeRoute(registration) {
                return '/astral/ui/dashboard/registrations/' + registration.id + '/cohorts/' + registration.cohort.id
            },

            simulationRoute(registration, simulation) {
                return '/astral/ui/dashboard/registrations/' + registration.id + '/simulations/' + simulation.id + '/cohorts/' + registration.cohort.id
            },

            issuesRoute(registration, simulation) {
                return '/astral/ui/log/registrations/' + registration.id + '/simulations/' + simulation.id + '/groups/0/issues'
            },
        }
    }
</script>

<style scoped>

    .registration {
        color: #525f7f;
        font-size: .875rem;
        font-weight: 600;
        margin-bottom: 10px;
    }

    .simulations {
        padding-left: 30px;
    }

    .simulation {
        color: #525f7f;
        font-size: 80%;
        font-weight: 400;
        margin-bottom: 10px;
    }

    .simulation >>> a {
        color: #5e72e4;
        font-weight: 400;
    }
    .simulation >>> a:hover {
        color: #233dd2;
    }

</style>